import { Probe } from "@/pages/eaf/data-entry/models/eaf.models";
import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef, ValueGetterParams } from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Probes",
      children: [
        {
          field: "Timestamp",
          headerName: "Time",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Probe>) => {
            if (params?.data?.Timestamp) {
              return dxtToLocalServerTime(params?.data?.Timestamp, "HH:mm");
            }
          },
        },
        {
          field: "Temperature",
          headerName: "Temp",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.Temperature?.toFixed(0) || "0",
          flex: 2,
        },
        {
          field: "MWH",
          headerName: "MWH",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.MWH?.toFixed(1) || "0",
          flex: 2,
        },
        {
          field: "Oxygen",
          headerName: "O2",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.Oxygen?.toFixed(1) || "0",
          flex: 2,
        },
        {
          field: "Carbon",
          headerName: "Carbon",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.Carbon?.toFixed(3) || "0",
          flex: 2,
        },
      ],
    },
  ];

  return { columns };
};
